<template>
  <component-preview
    v-if="scoringCriteria.length > 0"
    :heading="lang.get('judging.preview.heading')"
    class="mbx"
  >
    <div
      v-for="criterion in scoringCriteria"
      :key="'preview-' + criterion.id"
      class="form-group"
    >
      <h3 v-if="criterion.translated[language]['label']">
        {{ criterion.translated[language]['label'] }}
      </h3>
      <scoring-criterion
        :scoring-control="criterion.scoringControl"
        :minimum-score="criterion.minimumScore || 0"
        :maximum-score="criterion.maximumScore || 0"
        :scoring-increment="criterion.scoringIncrement"
      ></scoring-criterion>
    </div>
  </component-preview>
</template>

<script>
import { mapState } from 'vuex';
import ComponentPreview from '@/lib/components/ComponentPreview';
import ScoringCriterion from '@/lib/components/ScoringCriteria/ScoringCriterion';

export default {
  inject: ['lang'],
  components: {
    ComponentPreview,
    ScoringCriterion
  },
  props: {
    language: {
      type: String,
      default: 'en_GB'
    }
  },
  computed: {
    ...mapState('judgingFastStart', ['scoringCriteria'])
  }
};
</script>
